module.exports = __webpack_public_path__ + "static/Sams_pin_hover-5360449c3304dfefa2c020d097e42a01.png";